<template>
   <div class="pr-0 md:pr-4 mb-8">
      <div id="specs" class="product-tab overflow-x-auto">
         <strong class="text-xl font-bold mb-4 block pl-3">Specificaties</strong>

         <table class="w-full specs">
            <tbody>
               <product-specs-value
                  v-for="(option, index) in options.attributes"
                  :key="option.id"
                  :option="option"
                  :gray="index % 2 !== 0"
               />
            </tbody>
         </table>

         <div class="" v-for="(group, index) in options.groups" :key="index">
            <div class="mt-8" v-if="group.attribute.length">
               <strong class="pl-3 uppercase text-sm">{{ group.group.name }}</strong>
            </div>
            <table class="w-full" v-if="group.attribute.length">
               <tbody>
                  <product-specs-value
                     v-for="(option, index) in group.attribute"
                     :key="option.id"
                     :option="option"
                     :gray="index % 2 !== 0"
                  />
               </tbody>
            </table>
         </div>
      </div>
   </div>
</template>

<script>
import ProductSpecsValue from '@/Components/ProductSpecsValue.vue';

export default {
   props: ['product', 'options'],

   components: {
      ProductSpecsValue,
   },
};
</script>
